import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearchDesktop = () => (
  // <svg
  //   className={css.iconSvg}
  //   width="21"
  //   height="22"
  //   viewBox="0 0 21 22"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g
  //     className={css.iconSvgGroup}
  //     transform="matrix(-1 0 0 1 20 1)"
  //     strokeWidth="2"
  //     fill="none"
  //     fillRule="evenodd"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   >
  //     <path d="M13 14l5.241 5.241" />
  //     <circle cx="7.5" cy="7.5" r="7.5" />
  //   </g>
  // </svg>
  <svg  className={css.iconSvg} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.5 18L22 22.5M20 11.5C20 9.11305 19.0518 6.82387 17.364 5.13604C15.6761 3.44821 13.3869 2.5 11 2.5C8.61305 2.5 6.32387 3.44821 4.63604 5.13604C2.94821 6.82387 2 9.11305 2 11.5C2 13.8869 2.94821 16.1761 4.63604 17.864C6.32387 19.5518 8.61305 20.5 11 20.5C13.3869 20.5 15.6761 19.5518 17.364 17.864C19.0518 16.1761 20 13.8869 20 11.5Z" stroke="#1A1B2F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  
);

export default IconSearchDesktop;
